import { render, staticRenderFns } from "./RecommendedLayout.vue?vue&type=template&id=4cb161bd&scoped=true&"
import script from "./RecommendedLayout.vue?vue&type=script&lang=js&"
export * from "./RecommendedLayout.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedLayout.vue?vue&type=style&index=0&id=4cb161bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb161bd",
  null
  
)

export default component.exports